module.exports = __webpack_public_path__ + "static/name-f73f1b7233534ab5dadfbecf61671e24.png";